import { render, staticRenderFns } from "./FormUnitBasic.vue?vue&type=template&id=3999065a&scoped=true&"
import script from "./FormUnitBasic.vue?vue&type=script&lang=js&"
export * from "./FormUnitBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3999065a",
  null
  
)

export default component.exports